<template>
  <div class="page-builder-layout">
    <main-head-component/>
    <div class="container not_found_page mb-20">
      <div class="position-relative">
        <div class="not_found_page-number-bg">
          <img src="/images/icons/not_found.svg" alt="image"/>
        </div>
        <div class="position-relative not_found_page-number">
          404
        </div>
      </div>
      <div class="not_found_page-desc">{{$t('text.page_not_found')}}</div>
      <default-button
        :href="go_to_home"
        class="mt-20">
        {{$t('text.go_to_home')}}
      </default-button>
    </div>
    <footer-component/>
  </div>
</template>

<script>

import FooterComponent from "../parts/FooterComponent.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import {LOCALE_PREFIX} from "../../helpers/constants";
import MainHeadComponent from "../builder_components/MainHeadComponent.vue";

export default {
  name: "PageBuilderLayout",
  mixins: [],
  components: {
    MainHeadComponent,
    DefaultButton,
    FooterComponent,
  },
  computed: {
    go_to_home() {
      if (LOCALE_PREFIX) return `/${LOCALE_PREFIX}`
      return '/'
    },
    components_data() {
      return this.item.components || []
    },
  },
}
</script>
